import { Route } from 'react-router-dom';
import { BackOfficeMain } from 'app/agriculture/routes/BackOffice/BackOfficeMain';
import { UserHome } from 'app/agriculture/routes/BackOffice/UserHome/UserHome';
import { UserProfile } from 'app/agriculture/routes/BackOffice/UserProfile/UserProfile';
import { FarmCreate } from 'app/agriculture/routes/BackOffice/FarmCreate/FarmCreate';
import { FarmSettingsRoot } from 'app/agriculture/routes/BackOffice/FarmSettingsRoot';
import { FarmEdit } from 'app/agriculture/routes/BackOffice/Settings/FarmEdit/FarmEdit';
import { FarmUsers } from 'app/agriculture/routes/BackOffice/Settings/FarmUsers';
import { FarmUserInvite } from 'app/agriculture/routes/BackOffice/Settings/FarmUserInvite';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { UserHomeSkeleton } from './UserHome/UserHomeSkeleton';

export const backOfficeRoutes = (
    <Route element={<BackOfficeMain />}>
        <Route
            index
            element={
                <SuspenseWrapper loadingComponent={<UserHomeSkeleton />}>
                    <UserHome />
                </SuspenseWrapper>
            }
        />
        <Route path="profile" element={<UserProfile />} />
        <Route path="create-farm" element={<FarmCreate />} />
        <Route path="farms/:farmId" element={<FarmSettingsRoot />}>
            <Route path="edit" element={<FarmEdit />} />
            <Route path="users" element={<FarmUsers />} />
            <Route path="users/invite" element={<FarmUserInvite />} />
        </Route>
    </Route>
);
